import {
    getValidationMessage,
    type DynomiteError,
} from 'src/lib/utils/dynomite/ErrorMessageUtil';
import type { ErrorEntry } from '@typings';
import { formatSyntaxError } from '..';

export const toErrorEntries = (
    items: DynomiteError[] | undefined | null,
    type: 'error' | 'warning' = 'error',
    isDynomiteInternalError?: boolean,
): ErrorEntry[] => {
    if (isDynomiteInternalError) {
        return [
            {
                type,
                content:
                    'Tolkning av data feilet (du får fortsatt lov til å lagre)',
            },
        ];
    }
    return (items ?? []).map((err) =>
        err.tag !== 'syntax'
            ? { type, content: getValidationMessage(err), html: true }
            : { type, content: formatSyntaxError(err) },
    );
};
